import { useEffect, useRef, useState } from "react";
import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";
import "./Delhi-ielts.css";
import "./NewPage.css";
import {
  FaBuilding,
  FaSignal,
  FaMapMarkerAlt,
  FaClock,
  FaCompass,
  FaPhone,
  FaPenFancy,
} from "react-icons/fa";
import {
  CheckCircle,
  Users,
  BookOpen,
  RefreshCw,
  Globe,
  Briefcase,
} from "lucide-react";

import {
  DetailsFormJSon,
  DetailsFormJSon_Step2,
  getBatches,
} from "../LandingPage/LandingPageModel";
import { useDispatch } from "react-redux";
import { Test_Book } from "../../Action/ContactAction";
import { TEST_BOOKING_RESET } from "../../Constant/ContactConstant";
import { useSelector } from "react-redux";
import Loading from "../../Components/Loading";
import { Helmet } from "react-helmet";
import { Form2Submit, Form3Submit } from "../../Action/FreeClassAction";
import { useNavigate } from "react-router-dom";
import { STEP_3_FORM_RESET } from "../../Constant/FreeClassConctant";
import { BsShieldFillCheck } from "react-icons/bs";
import { MdSecurity } from "react-icons/md";

export default function FreeClassForm2() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [Batches, setBatches] = useState([]);
  const [Contact_Id, setContact_Id] = useState(0);
  const [StudentForm, setStudentForm] = useState(DetailsFormJSon);
  const [StudentForm2, setStudentForm2] = useState(DetailsFormJSon_Step2);
  const [StudentForm3, setStudentForm3] = useState({
    Question1: "Why do you want to take IELTS / PTE ?",
    Answer1: "...",
  });

  const Mobile_Screen = window.innerWidth;
  const dispatch = useDispatch();
  const why_choose = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    afterChange: (current) => setCurrentSlide(current),
    slidesToShow: Mobile_Screen <= 480 ? 1 : 3,
    slidesToScroll: 1,
  };
  const { loading, success, error } = useSelector((s) => s.Test_Book_Reducer);
  const {
    loading: Loading2,
    success: Success2,
    error: Error2,
    URL,
  } = useSelector((s) => s.Form2SubmitReducer);

  const {
    loading: Loading3,
    success: Success3,
    error: Error3,
  } = useSelector((s) => s.Form3SubmitReducer);
  const formRef = useRef(null);

  const [currentStep, setCurrentStep] = useState(0);

  const steps = [0, 1, 2];

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    e.preventDefault();
    dispatch(
      Form3Submit(Contact_Id, {
        ...StudentForm3,
        url: window.location.href,
      }),
    );
    // window.location.href = "/thank-you.html"; // or use react-router
  };

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleChange = (e) => {
    setStudentForm({ ...StudentForm, [e.target.name]: e.target.value });
  };

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};

    // Name validation
    if (!StudentForm?.name?.trim()) {
      newErrors.name = "Name is required";
    }

    // Email validation
    if (!StudentForm?.email?.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(StudentForm.email)) {
        newErrors.email = "Please enter a valid email address";
      }
    }

    // Phone validation (10 digits only)
    if (!StudentForm?.phone?.trim()) {
      newErrors.phone = "Phone number is required";
    } else {
      const phoneRegex = /^[0-9]{10}$/;
      if (!phoneRegex.test(StudentForm.phone)) {
        newErrors.phone = "Phone number must be exactly 10 digits";
      }
    }

    // City validation
    if (!StudentForm?.city?.trim()) {
      newErrors.city = "City is required";
    }

    setErrors(newErrors);

    // return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const validateForm2 = () => {
    let newErrors = {};

    // Course validation
    if (!StudentForm2?.Course_Id) {
      newErrors.Course_Id = "Course is required";
    }

    // Class Type validation (1 = Online, 2 = Offline)
    if (!StudentForm2?.ClassType) {
      newErrors.ClassType = "Class type is required";
    }

    // Slot validation
    if (!StudentForm2?.Slot) {
      newErrors.Slot = "Slot is required";
    }

    setErrors(newErrors);

    // return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const errorInputStyle = {
    border: "1px solid red",
  };

  const errorTextStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "4px",
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();
    setErrors({});

    if (!validateForm()) {
      return; // stop submit if validation fails
    }
    dispatch(
      Test_Book(
        {
          ...StudentForm,
          url: window.location.href,
        },
        "/student/free/class",
      ),
    );
  };

  const handleSubmit2 = (e) => {
    e.preventDefault();
    setErrors({});

    if (!validateForm2()) {
      return; // stop submit if validation fails
    }
    dispatch(
      Form2Submit(Contact_Id, {
        ...StudentForm2,
        url: window.location.href,
      }),
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (Success2) {
      if (Success2 == "already Taken TLAT") {
        window.location.href = URL;
      } else {
        nextStep();
      }
    }

    // if (error) {
    // }
  }, [Success2, dispatch]);

  useEffect(() => {
    if (Success3) {
      window.location.href = Success3;
      setTimeout(() => {
        dispatch({ type: STEP_3_FORM_RESET });
      }, 4000);
    }

    // if (error) {
    // }
  }, [Success3, dispatch]);

  useEffect(() => {
    if (success) {
      setContact_Id(success);
      nextStep();
      //   setStudentForm({ ...DetailsFormJSon });
      setTimeout(() => {
        dispatch({ type: TEST_BOOKING_RESET });
      }, 6000);
    }

    // if (error) {
    // }
  }, [success, dispatch]);

  useEffect(() => {
    if (StudentForm2?.ClassType && StudentForm2?.Course_Id) {
      setBatches(getBatches(StudentForm2?.Course_Id, StudentForm2?.ClassType));
    } else {
      setBatches([]);
    }
  }, [StudentForm2]);
  console.log(Batches);

  return (
    <div>
      <Helmet>
        {/* <!-- Primary Meta Tags --> */}
        <meta
          name="title"
          content="Free IELTS Coaching in Delhi | Testifyi – 8+ Band Results"
        />
        <meta
          name="description"
          content="Looking for the best IELTS coaching in Delhi? Testifyi offers expert guidance, flexible batches, and proven 8+ band results."
        />
        <meta
          name="keywords"
          content="Book Test for IELTS & PTE, IELTS Reality Test, PTE Reality Test, IELTS & PTE reality test, testifyi reality test, TRT test, IELTS Coaching"
        />

        {/* <!-- Canonical --> */}
        <link
          rel="canonical"
          href="https://testifyi.com/ielts-coaching-in-delhi"
        />

        {/* <!-- Robots --> */}
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />

        {/* <!-- Open Graph / Facebook --> */}
        <meta
          property="og:title"
          content="Best IELTS Coaching in Delhi | Testifyi – 8+ Band Results"
        />
        <meta
          property="og:description"
          content="Looking for the best IELTS coaching in Delhi? Testifyi offers expert guidance, flexible batches, and proven 8+ band results."
        />
        <meta
          property="og:url"
          content="https://testifyi.com/ielts-coaching-in-delhi"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://testifyi.com/assets/images/Banner.png"
        />

        {/* <!-- Twitter Card --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Best IELTS Coaching in Delhi | Testifyi – 8+ Band Results"
        />
        <meta
          name="twitter:description"
          content="Looking for the best IELTS coaching in Delhi? Testifyi offers expert guidance, flexible batches, and proven 8+ band results."
        />
        <meta
          name="twitter:image"
          content="https://testifyi.com/assets/images/Banner.png"
        />

        {/* <!-- Viewport --> */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* <!-- Language --> */}
        <meta http-equiv="Content-Language" content="en" />

        {/* <!-- Charset --> */}
        <meta charset="UTF-8" />

        {/* <!-- Theme Color (optional for browsers/mobile UI) --> */}
        <meta name="theme-color" content="#0A3AFF" />

        {/* <!-- Favicon (update with your actual path) --> */}

        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="1 days" />
        <meta name="author" content="Testifyi" />
        <title>Best IELTS Coaching in Delhi | Testifyi – 8+ Band Results</title>
      </Helmet>
      {loading || Loading2 || Loading3 ? <Loading /> : ""}
      <Navbar2 />
      <div className="Delhi_Ielts new_page_add">
        <div class="container1">
          {/* <!-- Main Content Area --> */}
          <div class="main-content">
            {/* <!-- Left Section --> */}
            <div class="left-section">
              <h1 class="main-heading">
                Absolutely Free
                <br />
                IELTS & PTE Classes
              </h1>

              <div class="subheading">
                <p>No Hidden Charges.</p>
                <p>Online & Offline Options.</p>
              </div>

              <div class="features">
                <div class="">
                  <div
                    class="feature-icon  feature-item"
                    style={{ color: "#2EAD96" }}
                  >
                    <MdSecurity />
                  </div>
                  <p
                    class="feature-text"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7.5 13.475L4.025 10L2.858 11.175L7.5 15.817L17.5 5.817L16.325 4.642L7.5 13.475Z"
                        fill="#10B981"
                      />
                    </svg>
                    100% Free
                  </p>
                </div>
                <div class="">
                  <div
                    class="feature-icon feature-item"
                    style={{ color: "#204999" }}
                  >
                    <BsShieldFillCheck />
                  </div>
                  <p
                    class="feature-text"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <svg
                      width="20"
                      style={{ marginTop: "-10px" }}
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7.5 13.475L4.025 10L2.858 11.175L7.5 15.817L17.5 5.817L16.325 4.642L7.5 13.475Z"
                        fill="#10B981"
                      />
                    </svg>
                    No Sales
                    <br />
                    Pressure
                  </p>
                </div>
              </div>

              <button
                class="cta-button primary"
                onClick={() => window.scrollTo(0, 0)}
              >
                Book Your Free Slot
              </button>
            </div>

            {/* <!-- Right Section - Form --> */}
            <div class="right-section Free_Form">
              <div class="form-container">
                <h2 class="form-heading">Register for Free Class</h2>

                <form onSubmit={handleSubmit} class="registration-form">
                  {/* STEP 1 */}
                  {currentStep === 0 && (
                    <div className="step active">
                      <div className="field">
                        <input
                          class="form-input"
                          type="text"
                          name="name"
                          value={StudentForm?.name}
                          onChange={handleChange}
                          placeholder="Enter your full name"
                          required
                          style={errors.name ? errorInputStyle : { border: "" }}
                        />

                        {errors?.name ? (
                          <div style={errorTextStyle}>{errors.name}</div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="field">
                        <input
                          type="email"
                          name="email"
                          value={StudentForm.email}
                          onChange={handleChange}
                          placeholder="Enter your email"
                          required
                          class="form-input"
                          style={
                            errors.email ? errorInputStyle : { border: "" }
                          }
                        />

                        {errors?.email ? (
                          <div style={errorTextStyle}>{errors.email}</div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="field">
                        <input
                          type="tel"
                          name="phone"
                          value={StudentForm.phone}
                          onChange={(e) => {
                            if (e.target.value?.length <= 10) {
                              handleChange(e);
                            }
                          }}
                          class="form-input"
                          placeholder="Enter your phone number"
                          required
                          style={
                            errors.phone ? errorInputStyle : { border: "" }
                          }
                        />

                        {errors?.phone ? (
                          <div style={errorTextStyle}>{errors.phone}</div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="field">
                        <input
                          type="text"
                          name="city"
                          value={StudentForm.city}
                          onChange={handleChange}
                          placeholder="Enter your city"
                          required
                          class="form-input"
                          style={errors.city ? errorInputStyle : { border: "" }}
                        />

                        {errors?.city ? (
                          <div style={errorTextStyle}>{errors.city}</div>
                        ) : (
                          ""
                        )}
                      </div>
                      {error ? <div style={errorTextStyle}>{error}</div> : ""}

                      <div className="buttons">
                        <button
                          type="button"
                          class="submit-button"
                          onClick={handleSubmit1}
                        >
                          Submit & Book Slot
                        </button>
                      </div>
                    </div>
                  )}

                  {/* STEP 2 */}
                  {currentStep === 1 && (
                    <div className="step active">
                      <div className="field">
                        <label>Choose Course</label>
                        <div className="radio-group">
                          {[
                            {
                              _id: "670cdc063ac09dd1afe0b5af",
                              name: "IELTS",
                            },
                            { _id: "670cdc0a3ac09dd1afe0b5b4", name: "PTE" },
                          ].map((course) => (
                            <div
                              key={course?._id}
                              className={`radio-box ${
                                StudentForm2?.Course_Id === course._id
                                  ? "selected"
                                  : ""
                              }`}
                              onClick={() =>
                                setStudentForm2({
                                  ...StudentForm2,
                                  Course_Id: course._id,
                                })
                              }
                            >
                              <input
                                type="radio"
                                name="Course_Id"
                                class="form-input"
                                checked={StudentForm2?.Course_Id === course._id}
                                style={{ color: "black" }}
                                readOnly
                              />
                              {course?.name}
                            </div>
                          ))}
                        </div>
                        {errors?.Course_Id ? (
                          <div style={errorTextStyle}>{errors.Course_Id}</div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="field">
                        <label>Class Type</label>
                        <select
                          value={StudentForm2?.ClassType}
                          name="ClassType"
                          onChange={(e) =>
                            setStudentForm2({
                              ...StudentForm2,
                              ClassType: e.target.value,
                            })
                          }
                          required
                          style={
                            errors.ClassType ? errorInputStyle : { border: "" }
                          }
                        >
                          <option value="">Choose Class Type</option>
                          <option value={1}>Online</option>
                          <option value={2}>Offline</option>
                        </select>

                        {errors?.ClassType ? (
                          <div style={errorTextStyle}>{errors.ClassType}</div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="field">
                        <label>Select Slot</label>
                        <select
                          value={StudentForm2?.Slot}
                          name="Slot"
                          onChange={(e) =>
                            setStudentForm2({
                              ...StudentForm2,
                              Slot: `${
                                Batches?.find((ev) => ev?.id == e.target.value)
                                  ?.time
                              } -${
                                Batches?.find((ev) => ev?.id == e.target.value)
                                  ?.location
                              }`,
                              //   Batch_Id: e.target.value,
                            })
                          }
                          required
                          style={errors.Slot ? errorInputStyle : { border: "" }}
                        >
                          <option value="">Choose a slot</option>
                          {Batches?.map((ev) => (
                            <option value={ev?.id} key={ev?.id}>
                              {ev?.time} - {ev?.location}
                            </option>
                          ))}
                        </select>
                        {errors?.Slot ? (
                          <div style={errorTextStyle}>{errors.Slot}</div>
                        ) : (
                          ""
                        )}
                      </div>
                      {Error2 && <div style={errorTextStyle}>{Error2}</div>}

                      <div className="buttons">
                        {/* <button
                                            type="button"
                                            className="btn-prev"
                                            onClick={prevStep}
                                          >
                                            Back
                                          </button> */}

                        <button
                          type="button"
                          class="submit-button"
                          onClick={handleSubmit2}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}

                  {/* STEP 3 */}
                  {currentStep === 2 && (
                    <div className="step active">
                      {/* <div className="question">
                        <p> Why do you want to take IELTS / PTE ?</p>
                        <label>
                          <input
                            type="radio"
                            name="Answer1"
                            onChange={() =>
                              setStudentForm3({
                                ...StudentForm3,
                                Answer1: "Study Visa",
                              })
                            }
                            value={StudentForm3.Answer1}
                            checked={StudentForm3.Answer1 === "Study Visa"}
                          />{" "}
                          Study Visa
                        </label>
                        <br />
                        <label>
                          <input
                            type="radio"
                            name="Answer1"
                            onChange={() =>
                              setStudentForm3({
                                ...StudentForm3,
                                Answer1: "Work Visa",
                              })
                            }
                            value={StudentForm3.Answer1}
                            checked={StudentForm3.Answer1 === "Work Visa"}
                          />
                          Work Visa
                        </label>
                        <br />
                        <label>
                          <input
                            type="radio"
                            name="Answer1"
                            onChange={() =>
                              setStudentForm3({
                                ...StudentForm3,
                                Answer1: "Migration / PR",
                              })
                            }
                            value={StudentForm3.Answer1}
                            checked={StudentForm3.Answer1 === "Migration / PR"}
                          />{" "}
                          Migration / PR
                        </label>
                        <br />
                        <label>
                          <input
                            type="radio"
                            name="Answer1"
                            onChange={() =>
                              setStudentForm3({
                                ...StudentForm3,
                                Answer1: "Other",
                              })
                            }
                            value={StudentForm3.Answer1}
                            checked={StudentForm3.Answer1 === "Other"}
                          />{" "}
                          Other
                        </label>
                      </div> */}
                      <div className="question">
                        <p>Why do you want to take IELTS / PTE?</p>

                        <div
                          style={{
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns:
                              window.innerWidth <= 490 ? "100%" : "55% 55%",
                            gap: "6px 10px",
                          }}
                        >
                          {[
                            "Study Visa",
                            "Work Visa",
                            "Migration / PR",
                            "Other",
                          ].map((item) => (
                            <label
                              key={item}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              {/* Radio 10% */}
                              <span
                                style={{
                                  width:
                                    window.innerWidth <= 490 ? "20%" : "10%",
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <input
                                  type="radio"
                                  name="Answer1"
                                  style={{ marginTop: "-2px" }}
                                  onChange={() =>
                                    setStudentForm3({
                                      ...StudentForm3,
                                      Answer1: item,
                                    })
                                  }
                                  checked={StudentForm3.Answer1 === item}
                                />
                              </span>

                              {/* Text 40% */}
                              <span
                                style={{
                                  width:
                                    window.innerWidth <= 490 ? "90%" : "40%",
                                  fontSize: "13px",
                                }}
                              >
                                {item}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>

                      {Error3 && <div style={errorTextStyle}>{Error3}</div>}

                      <button
                        type="submit"
                        class="submit-button"
                        className="submit-btn"
                      >
                        Submit & Continue
                      </button>
                    </div>
                  )}
                  <p class="form-footer">Your information is safe with us</p>
                </form>
              </div>
            </div>
          </div>

          {/* <!-- Free Section --> */}
          <section class="free-section">
            <div class="free-content-box">
              <h2 class="section-title">Yes, It's Really Free – No Catch</h2>
              <div class="free-points">
                <div class="point-item">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M7.5 13.475L4.025 10L2.858 11.175L7.5 15.817L17.5 5.817L16.325 4.642L7.5 13.475Z"
                      fill="#10B981"
                    />
                  </svg>
                  <span>No Hidden Conditions</span>
                </div>
                <div class="point-item">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M7.5 13.475L4.025 10L2.858 11.175L7.5 15.817L17.5 5.817L16.325 4.642L7.5 13.475Z"
                      fill="#10B981"
                    />
                  </svg>
                  <span>No Forced Enrollment</span>
                </div>
                <div class="point-item">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M7.5 13.475L4.025 10L2.858 11.175L7.5 15.817L17.5 5.817L16.325 4.642L7.5 13.475Z"
                      fill="#10B981"
                    />
                  </svg>
                  <span>Just Real Learning</span>
                </div>
              </div>
            </div>
          </section>

          {/* <!-- Learning Mode Section --> */}
          <section class="learning-mode-section">
            <h2 class="section-title">Choose Your Learning Mode</h2>
            <div class="mode-grid">
              <div class="mode-card">
                <h3 class="mode-title">Online Classes</h3>
                <div class="mode-feature">
                  <div class="mode-icon blue">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="2"
                        y="6"
                        width="20"
                        height="12"
                        rx="2"
                        fill="white"
                      />
                      <circle cx="12" cy="12" r="3" fill="#2563EB" />
                    </svg>
                  </div>
                  <span>Live Sessions</span>
                </div>
                <div class="mode-feature">
                  <div class="mode-icon blue">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="2"
                        y="6"
                        width="20"
                        height="12"
                        rx="2"
                        stroke="white"
                        stroke-width="2"
                        fill="#2563EB"
                      />
                      <path d="M2 10h20" stroke="white" stroke-width="2" />
                    </svg>
                  </div>
                  <span>Learn from Anywhere</span>
                </div>
              </div>
              <div class="mode-card">
                <h3 class="mode-title">Offline Classes</h3>
                <div class="mode-feature">
                  <div class="mode-icon orange">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 3L2 8v6c0 5.5 3.8 10.7 10 12 6.2-1.3 10-6.5 10-12V8l-10-5z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <span>Classroom Training</span>
                </div>
                <div class="mode-feature">
                  <div class="mode-icon orange">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="4" y="8" width="16" height="12" fill="white" />
                      <path d="M4 8l8-4 8 4" stroke="white" stroke-width="2" />
                    </svg>
                  </div>
                  <span>At Our Centers</span>
                </div>
              </div>
            </div>
            <p class="demo-text">This is a real class, not a demo.</p>
          </section>

          <div className="Free_New">
            <div className="New_Page_Free">
              {/* 
<!-- Benefits Section --> */}
              <section class="benefits-section">
                <div class="container">
                  <h2 class="section-title">
                    How You'll Benefit from This Free Course
                  </h2>
                  <p class="section-subtitle">
                    This free IELTS / PTE class helps you:
                  </p>

                  <div class="benefits-grid">
                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="16" y1="13" x2="8" y2="13" />
                          <line x1="16" y1="17" x2="8" y2="17" />
                          <polyline points="10 9 9 9 8 9" />
                        </svg>
                      </div>
                      <p>Understand the exam format & scoring system</p>
                    </div>

                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                          <line x1="12" y1="9" x2="12" y2="13" />
                          <line x1="12" y1="17" x2="12.01" y2="17" />
                        </svg>
                      </div>
                      <p>Identify common mistakes students make</p>
                    </div>

                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                        </svg>
                      </div>
                      <p>Learn band-improvement strategies</p>
                    </div>

                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12 6 12 12 16 14" />
                        </svg>
                      </div>
                      <p>
                        Get clarity on how much preparation you actually need
                      </p>
                    </div>

                    <div class="benefit-card">
                      <div class="benefit-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M9 11l3 3L22 4" />
                          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                        </svg>
                      </div>
                      <p>Decide confidently whether coaching is required</p>
                    </div>
                  </div>

                  <div class="highlight-box">
                    <p>
                      <strong>
                        This is not a demo — it's a real learning session.
                      </strong>
                    </p>
                  </div>
                </div>
              </section>

              {/* <!-- Booking Steps Section --> */}
              <section class="booking-section">
                <div class="container">
                  <h2 class="section-title">
                    How to Book Your Free Class Slot
                  </h2>
                  <p class="section-subtitle">
                    Booking your free slot is simple and transparent:
                  </p>

                  <div class="steps-container">
                    <div class="step-card">
                      <div class="step-number">
                        <span>1</span>
                      </div>
                      <div class="step-content">
                        <h3>Step 1</h3>
                        <p>Fill out the registration form on this page.</p>
                      </div>
                    </div>

                    <div class="step-card">
                      <div class="step-number">
                        <span>2</span>
                      </div>
                      <div class="step-content">
                        <h3>Step 2</h3>
                        <p>
                          After submitting the form, you'll be redirected to the
                          T-LAT exam page.
                        </p>
                      </div>
                    </div>

                    <div class="step-card">
                      <div class="step-number">
                        <span>3</span>
                      </div>
                      <div class="step-content">
                        <h3>Step 3</h3>
                        <p>
                          You'll also receive the T-LAT exam link on email, so
                          you can attempt it later if you wish.
                        </p>
                      </div>
                    </div>

                    <div class="step-card">
                      <div class="step-number">
                        <span>4</span>
                      </div>
                      <div class="step-content">
                        <h3>Step 4</h3>
                        <p>
                          Appear for the T-LAT (Testifyi Language Assessment
                          Test):
                        </p>
                        <ul>
                          <li>
                            <strong>Duration:</strong> 10–15 minutes
                          </li>
                          <li>
                            <strong>Format:</strong> Simple English language
                            assessment
                          </li>
                          <li>
                            <strong>Total Marks:</strong> 60
                          </li>
                          <li>
                            <strong>Qualifying Score:</strong> 30/60
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* <!-- Why T-LAT Section --> */}
              <section class="tlat-section">
                <div class="container">
                  <div class="tlat-card">
                    <h2 class="section-title">Why T-LAT?</h2>
                    <p>
                      T-LAT helps us understand your current English language
                      level, so we can guide you better during the class.
                    </p>

                    <div class="info-boxes">
                      <div class="info-box">
                        <div class="info-icon">👉</div>
                        <div class="info-text">
                          <strong>Don't worry if you don't qualify.</strong>
                          <p>
                            Simply get in touch with the Testifyi Team, and
                            we'll help you explore an alternate way to avail
                            this free offer.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>

          {/* New section end */}
          <div class="Price_C">
            <div class="PriceComp">
              <div class="container">
                <div class="header3">
                  <h1>Choose Your Path to Success</h1>
              
                  <p>
                    Compare our Free and Paid IELTS / PTE preparation programs
                    and find the perfect fit for your goals
                  </p>
                </div>

                <div class="comparison-table">
                  {/* <!-- Table Header --> */}
                  <div class="table-header">
                    <div>
                      <h2 class="header-label">Features</h2>
                    </div>
                    <div>
                      <div class="icon-badge free">⭐</div>
                      <div class="plan-title">Free Classes</div>
                      <div class="plan-price">₹0 – Absolutely Free</div>
                    </div>
                    <div>
                      <div class="icon-badge paid">💎</div>
                      <div class="plan-title">Paid Classes</div>
                      <div class="plan-price">Starts from ₹7,000</div>
                    </div>
                  </div>

                  {/* <!-- Live Classes --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">🎥</span>
                      <span class="feature-name">Live Classes</span>
                    </div>
                    <div>
                      <span class="check-icon">✔ Live classes</span>
                    </div>
                    <div>
                      <span class="check-icon">✔ Live classes</span>
                    </div>
                  </div>

                  {/* <!-- Mode --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">🏫</span>
                      <span class="feature-name">Mode</span>
                    </div>
                    <div>
                      <span class="text-gray">Online & Offline</span>
                    </div>
                    <div>
                      <span class="text-gray">Online & Offline</span>
                    </div>
                  </div>

                  {/* <!-- Fast-Track Option --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">⚡</span>
                      <span class="feature-name">
                        Fast-Track Option
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            An accelerated preparation option designed for
                            students with shorter timelines or upcoming test
                            dates.
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="check-icon">✔ Available</span>
                    </div>
                    <div>
                      <span class="check-icon">✔ Available</span>
                    </div>
                  </div>

                  {/* <!-- Class Timings --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">🕒</span>
                      <span class="feature-name">
                        Class Timings
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            Class schedules available for students. Paid
                            programs offer more flexibility compared to
                            predefined slots in free classes.
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="text-gray text-small">
                        ⏱ Limited, pre-defined slots
                      </span>
                    </div>
                    <div>
                      <span class="text-gray text-small">
                        🕒 Multiple flexible time slots
                      </span>
                    </div>
                  </div>

                  {/* <!-- Number of Classes --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">📚</span>
                      <span class="feature-name">
                        Number of Classes
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            Total number of instructor-led sessions included in
                            the program.
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="text-gray">Up to 12 classes</span>
                    </div>
                    <div>
                      <span class="text-gray">Minimum 25 classes</span>
                    </div>
                  </div>

                  {/* <!-- Study Material --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">📖</span>
                      <span class="feature-name">
                        Study Material
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            Curated practice resources and learning material
                            aligned with the IELTS / PTE exam structure.
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="text-gray">Limited material</span>
                    </div>
                    <div>
                      <span class="text-gray">
                        Comprehensive study material
                      </span>
                    </div>
                  </div>

                  {/* <!-- Testifyi AI Prep Platform --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">🤖</span>
                      <span class="feature-name">
                        Testifyi AI Prep Platform
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            An AI-powered practice platform that analyses your
                            performance and helps you focus on improvement areas
                            through smart exercises and insights.
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="cross-icon">❌ Not included</span>
                    </div>
                    <div>
                      <span class="check-icon">✔ Included</span>
                    </div>
                  </div>

                  {/* <!-- Mock Tests --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">📝</span>
                      <span class="feature-name">
                        Mock Tests
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            Full-length practice tests designed to simulate the
                            real IELTS / PTE exam experience and help you assess
                            your readiness.
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="cross-icon">❌ Not included</span>
                    </div>
                    <div>
                      <span class="check-icon">✔ Included</span>
                    </div>
                  </div>

                  {/* <!-- Testifyi Reality Test --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">📊</span>
                      <span class="feature-name">
                        Testifyi Reality Test
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            A diagnostic test that helps estimate your current
                            exam level and highlights strengths and areas for
                            improvement before the actual test.
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="cross-icon">❌ Not included</span>
                    </div>
                    <div>
                      <span class="check-icon">✔ Included</span>
                    </div>
                  </div>

                  {/* <!-- Doubt Sessions --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">💬</span>
                      <span class="feature-name">
                        Doubt Sessions
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            Dedicated sessions where students can clarify
                            questions and concepts with trainers, either in a
                            group or one-on-one (as applicable).
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="text-gray">👥 Group doubt sessions</span>
                    </div>
                    <div>
                      <span class="text-gray">
                        👥 Group + 👤 Individual sessions
                      </span>
                    </div>
                  </div>

                  {/* <!-- Personalised Practice & Feedback --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">🎯</span>
                      <span class="feature-name">
                        Personalised Practice & Feedback
                      </span>
                    </div>
                    <div>
                      <span class="text-gray">❌ Limited</span>
                    </div>
                    <div>
                      <span class="check-icon">✔ In-depth</span>
                    </div>
                  </div>

                  {/* <!-- Obligation to Enrol --> */}
                  <div class="table-row">
                    <div>
                      <span class="feature-icon">🔓</span>
                      <span class="feature-name">
                        Obligation to Enrol
                        <div class="tooltip-container">
                          <span class="info-icon">ⓘ</span>
                          <span class="tooltip-text">
                            Indicates whether students are required to enroll in
                            a paid program after attending the free class. Free
                            classes have no obligation.
                          </span>
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="check-icon">❌ None</span>
                    </div>
                    <div>
                      <span class="text-gray">Optional</span>
                    </div>
                  </div>

                  {/* <!-- CTA Footer --> */}
                  <div class="cta-footer">
                    <div></div>
                    <div>
                      <button
                        class="btn btn-free"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        Start Free Class
                      </button>
                    </div>
                    <div>
                      <button
                        class="btn btn-paid"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        Enroll Now
                      </button>
                    </div>
                  </div>
                </div>

                <div class="footer-note" style={{ marginBottom: "20px" }}>
                  💡 Hover over the ⓘ icon to learn more about each feature
                </div>
              </div>
            </div>
          </div>

          <div className="Free_New">
            <div className="New_Page_Free">
              {/* <!-- IELTS Reality Test Section --> */}
              <section class="reality-test-section">
                <div class="container">
                  <h2 class="section-title">Take the IELTS Reality Test</h2>
                  <p class="section-subtitle">
                    Students attending our free classes can also appear for the
                    IELTS Reality Test, which:
                  </p>

                  <div class="reality-test-grid">
                    <div class="reality-test-card">
                      <div class="reality-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          />
                          <line x1="16" y1="2" x2="16" y2="6" />
                          <line x1="8" y1="2" x2="8" y2="6" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                      </div>
                      <p>Simulates real exam conditions</p>
                    </div>

                    <div class="reality-test-card">
                      <div class="reality-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M3 3v18h18" />
                          <path d="M18 17V9" />
                          <path d="M13 17V5" />
                          <path d="M8 17v-3" />
                        </svg>
                      </div>
                      <p>Helps you estimate your current band level</p>
                    </div>

                    <div class="reality-test-card">
                      <div class="reality-icon">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                          <polyline points="22 4 12 14.01 9 11.01" />
                        </svg>
                      </div>
                      <p>Highlights strengths and improvement areas</p>
                    </div>
                  </div>

                  <div class="highlight-box">
                    <p>
                      <strong>
                        A great way to understand where you truly stand before
                        the actual exam.
                      </strong>
                    </p>
                  </div>
                </div>
              </section>

              {/* <!-- Who Should Attend Section --> */}
              <section class="who-should-attend-section">
                <div class="container">
                  <h2 class="section-title">
                    Who Should Attend This Free Class?
                  </h2>
                  <p class="section-subtitle">
                    This free IELTS / PTE class is ideal if you are:
                  </p>

                  <div class="audience-list">
                    <div class="audience-item">
                      <div class="check-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <p>Planning study abroad</p>
                    </div>

                    <div class="audience-item">
                      <div class="check-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <p>Preparing for work or migration</p>
                    </div>

                    <div class="audience-item">
                      <div class="check-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <p>A beginner unsure where to start</p>
                    </div>

                    <div class="audience-item">
                      <div class="check-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <p>Restarting preparation after a break</p>
                    </div>

                    <div class="audience-item">
                      <div class="check-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="3"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <p>Exploring whether coaching is required</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* <!-- Final CTA Section --> */}
              <section class="final-cta-section">
                <div class="container">
                  <div class="final-cta-content">
                    <h2>Start Your IELTS or PTE Journey — For Free</h2>
                    <p>
                      Get clarity, build confidence, and take your next step —
                      without paying anything.
                    </p>
                    <button
                      class="cta-button"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Book Your Free Slot Now
                    </button>
                  </div>
                </div>
              </section>
            </div>
          </div>

          {/* <!-- Bottom CTA Section --> */}
          {/* <section class="bottom-cta">
            <h2 class="cta-title">Start Your IELTS or PTE Journey for Free</h2>
            <p class="cta-subtitle">
              Get clarity before investing your time or money.
            </p>
            <button
              class="cta-button secondary"
              onClick={() => window.scrollTo(0, 0)}
            >
              Book Your Free Slot Now
            </button>
          </section> */}
        </div>
      </div>

      <Footer />
    </div>
  );
}
